// extracted by mini-css-extract-plugin
export default {"heading":"LandscapeIndicatorsTemplate_heading__fJyav","buttonRow":"LandscapeIndicatorsTemplate_buttonRow__cSaqg"};